import { create } from "zustand";

export const useBoundStore = create((set) => ({
  showOverlay: true,
  setShowOverlay: (value) => set({ showOverlay: value }),
}));

